'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptyFavourites: React.FC<BaseEmptyStateProps & { title?: string}> = (props) => {
  const t = useTranslations('emptyStates.favourites')

  return (
    <BaseEmptyState
      {...props}
      title={props.title || t('title')}
      description={t('description')}
      imageSrc="/emptyStates/favorite-product-illustration.svg"
      variant="subtle"
    />
  )
}